export const getRowKey = (record: any) => record.id;
